import * as React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { context } from '../context';

export const SearchTypeSelector = () => {
    const { searchType, setSearchType } = React.useContext(context);

    const handleChange = (event, newValue) => {
        if (newValue !== null) {
            setSearchType(newValue);
        }
    };

    return (
        <ToggleButtonGroup
            value={searchType}
            exclusive
            onChange={handleChange}
            size="small"
            sx={{
                '& .MuiToggleButton-root': {
                    px: 1.5,
                    py: 0.75,
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    border: '1px solid',
                    borderColor: 'divider',
                    color: 'text.secondary',
                    textTransform: 'none',
                    '&.Mui-selected': {
                        bgcolor: 'rgba(255, 139, 147, 0.1)',
                        borderColor: 'primary.main',
                        color: 'primary.main',
                        '&:hover': {
                            bgcolor: 'rgba(255, 139, 147, 0.15)',
                        },
                    },
                    '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.04)',
                    },
                },
                '& .MuiToggleButton-root:first-of-type': {
                    borderRadius: '8px 0 0 8px',
                },
                '& .MuiToggleButton-root:last-of-type': {
                    borderRadius: '0 8px 8px 0',
                },
            }}
        >
            <Tooltip title="搜索字幕内容">
                <ToggleButton value="subtitle">
                    <SubtitlesIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
                    字幕
                </ToggleButton>
            </Tooltip>
            <Tooltip title="搜索直播内容（AI 总结关键词）">
                <ToggleButton value="summary">
                    <AutoAwesomeIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
                    内容
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>
    );
};
